module.exports = __webpack_public_path__ + "img/default-discussion-image.20550a5a.png";